import { createContext } from 'react';

type color = 'primary' | 'tertiary' | 'secondary';
const defaultColor: color = 'primary';
const ColorContext = createContext<color>(defaultColor);
export default ColorContext;
